import React from 'react';
import { FaPlus, FaTrash } from 'react-icons/fa';

const PollForm = ({ pollQuestion, setPollQuestion, pollOptions, addPollOption, removePollOption, updatePollOption, pollDuration, setPollDuration }) => (
  <div className="space-y-4">
    <div>
      <label className="text-sm text-gray-600 mb-2 block">Poll Question</label>
      <textarea
        data-testid="poll-question-input"
        value={pollQuestion}
        onChange={(e) => setPollQuestion(e.target.value)}
        className="w-full bg-gray-100 border border-gray-300 focus:border-[#4A90E2] focus:ring-1 focus:ring-[#4A90E2] rounded-lg p-4 text-gray-900 placeholder:text-gray-400 transition-all outline-none min-h-[80px] resize-none"
        placeholder="Ask a question..."
        required
      />
    </div>

    <div>
      <label className="text-sm text-gray-600 mb-2 block">Poll Options</label>
      <div className="space-y-2">
        {pollOptions.map((option, index) => (
          <div key={`option-${index}`} className="flex items-center space-x-2">
            <input
              type="text"
              value={option}
              onChange={(e) => updatePollOption(index, e.target.value)}
              className="flex-1 bg-gray-100 border border-gray-300 focus:border-[#4A90E2] focus:ring-1 focus:ring-[#4A90E2] rounded-lg px-4 py-2 text-gray-900 placeholder:text-gray-400 transition-all outline-none"
              placeholder={`Option ${index + 1}`}
              data-testid={`poll-option-${index}`}
            />
            {pollOptions.length > 2 && (
              <button type="button" onClick={() => removePollOption(index)} className="text-red-500 hover:text-red-600 p-2">
                <FaTrash size={14} />
              </button>
            )}
          </div>
        ))}
      </div>
      {pollOptions.length < 4 && (
        <button type="button" onClick={addPollOption} className="mt-2 flex items-center space-x-2 text-[#4A90E2] hover:text-[#3A80D2] text-sm font-medium">
          <FaPlus size={12} />
          <span>Add option</span>
        </button>
      )}
    </div>

    <div>
      <label className="text-sm text-gray-600 mb-2 block">Poll Duration</label>
      <select
        value={pollDuration}
        onChange={(e) => setPollDuration(e.target.value)}
        className="w-full bg-gray-100 border border-gray-300 focus:border-[#4A90E2] rounded-lg px-4 py-2 text-gray-900 outline-none"
        data-testid="poll-duration"
      >
        <option value="1day">1 Day</option>
        <option value="3days">3 Days</option>
        <option value="1week">1 Week</option>
      </select>
    </div>
  </div>
);

export default PollForm;
